import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

import styles from "assets/jss/baseCardstyle.js";
import FadeInModal from "components/FadeInModal";

import { D3PieChart } from "./D3PieChart";
import BaseCardCopy from "./BaseCard";

import { Link } from "react-router-dom"
import D3LinearChartCopy from "./D3LinearChart";
import D3Bar from "./D3Bar";

const useStyles = makeStyles(styles);

export default function GraphCardCopy(props) {
    const { graphData, justDetailButton, institution } = props;
    const classes = useStyles();
    const [modalState, setModalState] = React.useState(false);
    //const [modalTitle, setModalTitle] = React.useState("");
    const closeModal = () => { //function to pass through props to FadeInModal
        setModalState(false);
    };

    return (
        <BaseCardCopy height={'96%'}>
            <div className={classes.graphCardHeader}>
                <Link to={"/viewChart/" + graphData.key} style={{ textDecoration: 'none' }} className={'new-institution-text'}>
                    <Typography variant="h2" className={classes.emphasizedHeader}>{graphData.title}</Typography>
                </Link>
                {
                    justDetailButton && (
                        <div className={classes.graphOptionsMenuContainer}>
                            <div className={classes.graphOptionsMenuButton} onClick={() => { /* setModalTitle(graphData.title); */ setModalState(true); }}>
                                <div className={classes.graphOptionsMenuIcon}>
                                    <i class="fas fa-info fa-1x"></i>
                                </div>
                                <Typography variant="subtitle2">Metodología</Typography>
                            </div>
                        </div>
                    )
                }
            </div>

            <div className={classes.graphCardContinerNew} style={{ textDecoration: 'none', paddingBottom: 0 }}>
                <Link to={"/viewChart/" + graphData.key} >
                    {
                        <div onMouseEnter={() => console.log('test')}>
                            <div>
                                {
                                    graphData.type === 4 ? <D3PieChart width={600} height={355} source={graphData.data} requiresLegends2 />
                                        :
                                        (graphData.type === 3 || graphData.type === 6 ? <D3Bar width={600} height={355} source={graphData.data} requiresLegends2 type={graphData.type} /> : <D3LinearChartCopy width={600} height={355} source={graphData.data} requiresLegends2 />)
                                }
                            </div>
                        </div>
                    }
                </Link>
            </div>

            {
                justDetailButton && (
                    <FadeInModal open={modalState} handleClose={closeModal} modalTitle={
                        graphData.title +
                        (
                            (props.variant && props.variant === "global") ? "" : (" del " + institution.name)
                        )
                    }
                    >

                        <Typography variant="caption">
                            <p>
                                <div dangerouslySetInnerHTML={{ __html: graphData.methodology }} />
                            </p>
                        </Typography>
                    </FadeInModal>
                )
            }
        </BaseCardCopy>
    );
}